import { useEffect } from 'react';
import { vehiclePublicAPI } from '../../lib/api';
import { buyerSessionId, buyerVisitId } from './useFormDraft';

/**
 * "Still here" heartbeat for the buyer-side screens AWAY from the showroom.
 *
 * The showroom itself does not use this: it already runs a 5s promotion poll,
 * and the heartbeat rides on that existing tick rather than adding a second
 * timer (see VehicleExperience.jsx). But the details, F&I and trade-in screens
 * have no such loop — and without one, a buyer who taps "Vehicle details" reads
 * as "Buyer left" on the sales desk 15 seconds later while they are still very
 * much in the experience. That would be a lie on a staff screen.
 *
 * Presence only. Writes nothing to the activity trail.
 */
const BEAT_MS = 5000;

export function useBuyerHeartbeat(cardId, sessionId = null) {
    useEffect(() => {
        if (!cardId) return;
        const sid = sessionId || buyerSessionId(cardId);
        if (!sid) return;
        const visit = buyerVisitId();
        const beat = () => { vehiclePublicAPI.presence(cardId, sid, visit).catch(() => {}); };
        beat();
        const iv = setInterval(() => { if (!document.hidden) beat(); }, BEAT_MS);
        const onVis = () => { if (!document.hidden) beat(); };
        document.addEventListener('visibilitychange', onVis);
        return () => { clearInterval(iv); document.removeEventListener('visibilitychange', onVis); };
    }, [cardId, sessionId]);
}

export default useBuyerHeartbeat;
